{
  "launching": "جاري تسجيل الدخول...",
  "changeLanguage": "تغيير اللغة",
  "logOut": "تسجيل الخروج"
}
